var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "16", height: "9", viewBox: "0 0 16 9", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.905 1.13042C14.43 0.694002 15.2281 0.744543 15.6874 1.24331C16.1468 1.74207 16.0936 2.50018 15.5686 2.9366L8.83179 8.53659C8.35555 8.93247 7.64445 8.93247 7.16821 8.53659L0.431379 2.9366C-0.0936346 2.50018 -0.146836 1.74207 0.312551 1.24331C0.771938 0.744543 1.56995 0.694002 2.09497 1.13042L8 6.03898L13.905 1.13042Z", fill: "#303030" })
  );
});